import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UIActions from '../../actions/UIActions';
import BrandUtils from '../../utils/BrandUtils';

const shrinkOn = 80;

class PageHeader extends Component {
  constructor(props) {
    super(props);

    this.expand = this.expand.bind(this);
    this.collapse = this.collapse.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      collapsed: false,
    };
  }

  componentDidMount() {
    this.expand();

    if (BrandUtils.isAbleToDisplay('page-header-without-text')) {
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  componentWillUnmount() {
    if (BrandUtils.isAbleToDisplay('page-header-without-text')) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll() {
    const distanceY = window.pageYOffset || document.documentElement.scrollTop;

    if (this.state.collapsed && distanceY < shrinkOn) {
      this.expand();
    } else if (!this.state.collapsed && distanceY >= shrinkOn) {
      this.collapse();
    }
  }

  collapse() {
    this.setState(
      {
        collapsed: true,
      },
      () => {
        UIActions.notifyHeaderCollapse();
      }
    );
  }

  expand() {
    this.setState(
      {
        collapsed: false,
      },
      () => {
        UIActions.notifyHeaderExpand();
      }
    );
  }

  render() {
    if (this.props.visible) {
      if (BrandUtils.isAbleToDisplay('page-header-with-text')) {
        return (
          <header className="row" role="banner">
            <div className="col-xs-12">
              <div className="row">
                <div className="col-xs-4">
                  <img
                    className="img-responsive"
                    src={BrandUtils.appendBrand('images/{}/logo.png')}
                    title={this.props.content.headerLogoAlt}
                    alt={this.props.content.headerLogoAlt}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12  header-title-column">
                  <h1>{this.props.title}</h1>
                </div>
              </div>
            </div>
          </header>
        );
      } else if (BrandUtils.isAbleToDisplay('page-header-without-text')) {
        return (
          <header
            className={`row ${this.state.collapsed ? 'smaller' : ''}`}
            role="banner"
          >
            <span className="screenreader">
              {this.props.content.headerLogoAlt}
            </span>
            <h1 className="screenreader">{this.props.title}</h1>
          </header>
        );
      }
    }
    return null;
  }
}

PageHeader.defaultProps = {
  visible: true,
};

PageHeader.propTypes = {
  content: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool,
};

export { PageHeader };
